// we're in a deeper folder than fields.js - assume it is loaded
PD.forms.fields.ToggleablePasswordField = (function(){
    function ToggleablePasswordField(cfg, index, form) {
      this._super.apply(this, arguments); // call generic TextField constructor
    }
    ToggleablePasswordField.prototype = {
      visible: false,
      _template: 
        '<div class="form-group">' +
          '<label for="<%=id%>" class="col-sm-3 control-label"><%=label?label+\':\':\'\'%></label>' +
          '<div class="cm-toggle-password col-sm-<%=helpText? "8" : "9"%>">' +
            '<input type="password" autocomplete="new-password" class="form-control" id="<%=id%>" name="<%=name%>" placeholder="<%=placeholder===false? \'\' : placeholder || label%>">' +
            '<button type="button" class="btn btn-text"><i class="fa fa-eye-slash"></i></button>'+
          '</div>' +
        '<% if (helpText) { %>' +
          '<div class="col-sm-1 hidden-xs">' +
            '<i class="fa fa-question-circle-o" role="button" data-toggle="popover" title="<%=helpText.title%>" data-content="<%=helpText.content%>"></i>'+
          '</div>' +
        '<% } %>' +
        '<% if (errorText) { %>' +
          '<div class="col-sm-9 col-sm-offset-3 error-text">' +
            '<p><%=errorText%></p>' +
          '</div>' +
        '<% } %>' +
        '<% if (inlineHelpText) { %>' +
          '<div class="col-sm-9 col-sm-offset-3 help-block">' +
            '<p><%=inlineHelpText%></p>' +
          '</div>' +
        '<% } %>' +
        '</div>',
  
        regex: /^.{6,}$/
    };

    var proto = ToggleablePasswordField.prototype;

    proto._get$Element = function() {
      var $elm = this._super.prototype._get$Element.apply(this);
      this.$toggleBtn = $elm.find("button");
      this.$toggleIcon = this.$toggleBtn.find(".fa");
      this.$toggleBtn.click(this.toggle.bind(this));
      return $elm;
    }

    proto.toggle = function() {
      this.visible = !this.visible;

      this.$inp.attr("type", this.visible ? "text" : "password");
      this.$toggleIcon.toggleClass("fa-eye", this.visible)
        .toggleClass("fa-eye-slash", !this.visible);
    }
  
    // inherit from generic field
    PD.forms.fields.register(["togglepassword", "toggleablepassword", "ToggleablePasswordField"], ToggleablePasswordField, PD.forms.fields.TextField);
  
    return ToggleablePasswordField;
  })();
